define( [
	"./class2type"
], function( class2type ) {
	return class2type.hasOwnProperty;
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/var/hasOwn.js
 ** module id = 823
 ** module chunks = 2
 **/